import { call, put, takeLatest } from 'redux-saga/effects';

import processesService from 'services/processesService';

import {
  deleteWorkStep,
  fetchQuoteWorkflow,
  fetchWorkSteps,
  types,
} from './actions';

export default function* root() {
  yield takeLatest(types.DELETE_WORK_STEP_REQUEST, watchDeleteWorkStep);
  yield takeLatest(types.FETCH_QUOTE_WORKFLOW_REQUEST, watchFetchQuoteWorkflow);
  yield takeLatest(types.FETCH_WORK_STEPS_REQUEST, watchWorkStepsFetch);
}

function* watchDeleteWorkStep(action) {
  const { workStepId } = action.payload;
  try {
    yield call(processesService.workSteps.delete, workStepId);
    yield put(fetchQuoteWorkflow.request());
    yield put(deleteWorkStep.success({ workStepId }));
  } catch (error) {
    yield put(deleteWorkStep.error(error));
  }
}

function* watchWorkStepsFetch() {
  try {
    const workSteps = yield call(processesService.workSteps.list);
    yield put(fetchWorkSteps.success({ workSteps }));
  } catch (error) {
    yield put(fetchWorkSteps.error(error));
  }
}

function* watchFetchQuoteWorkflow() {
  try {
    const workflows = yield call(processesService.workflows.list, {
      type: 'quote',
    });
    yield put(fetchQuoteWorkflow.success({ quoteWorkflow: workflows[0] }));
  } catch (error) {
    yield put(fetchQuoteWorkflow.error(error));
  }
}

export function* initSaga() {
  yield put(fetchWorkSteps.request());
  yield put(fetchQuoteWorkflow.request());
}
